import { Form, SubmitFormButton } from '@calendly/form'
import { object, string } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Body, Footer } from '@calendly/ui/components/popup'
import { useMemo } from 'react'

import { TextFieldWithCounter } from 'components/core/form'

import { Row } from './styles'


export const UserGroupPopup = ({ title, isOpen, onClose, onSubmit, initialValues, confirmLabel }) => {
  const maxLength = 50

  const validationSchema = useMemo(() => (
    object({
      name: string().required().max(maxLength)
    })
  ), [])

  return (
    <Popup
      title={title}
      isOpen={isOpen}
      onClose={onClose}
    >
      <Form
        initialValues={initialValues}
        onSubmit={async (values) => {
          await onSubmit(values)
          onClose()
        }}
        validationSchema={validationSchema}
      >
        <Body>
          <Row>
            <TextFieldWithCounter
              autoFocus
              name="name"
              label={I18n.t('publisher.organization.user_groups.form.name')}
              placeholder={I18n.t('publisher.organization.user_groups.form.name_placeholder')}
              lengthError={I18n.t('publisher.organization.user_groups.form.counter_validation_error')}
              maxLength={maxLength}
            />
          </Row>
        </Body>
        <Footer>
          <Button
            decoration="secondary-outline"
            onClick={onClose}
          >
            {I18n.t('publisher.action.cancel')}
          </Button>
          <SubmitFormButton>
            {confirmLabel}
          </SubmitFormButton>
        </Footer>
      </Form>
    </Popup>
  )
}
